/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Form_LabelInputs */

const en_transcript_export_form_label = /** @type {(inputs: Transcript_Export_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export Configuration`)
};

const fr_transcript_export_form_label = /** @type {(inputs: Transcript_Export_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuration de l'exportation`)
};

const de_transcript_export_form_label = /** @type {(inputs: Transcript_Export_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportkonfiguration`)
};

const it_transcript_export_form_label = /** @type {(inputs: Transcript_Export_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurazione di esportazione`)
};

const ru_transcript_export_form_label = /** @type {(inputs: Transcript_Export_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспорт конфигурации`)
};

const es_transcript_export_form_label = /** @type {(inputs: Transcript_Export_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuración de exportación`)
};

const zh_cn2_transcript_export_form_label = /** @type {(inputs: Transcript_Export_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导出配置`)
};

const ja_transcript_export_form_label = /** @type {(inputs: Transcript_Export_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エクスポート設定`)
};

const hi_transcript_export_form_label = /** @type {(inputs: Transcript_Export_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निर्यात कॉन्फ़िगरेशन`)
};

const pt_pt2_transcript_export_form_label = /** @type {(inputs: Transcript_Export_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar configuração`)
};

/**
* | output |
* | --- |
* | "Export Configuration" |
*
* @param {Transcript_Export_Form_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_form_label = /** @type {((inputs?: Transcript_Export_Form_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Form_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_transcript_export_form_label(inputs)
	if (locale === "de") return de_transcript_export_form_label(inputs)
	if (locale === "it") return it_transcript_export_form_label(inputs)
	if (locale === "ru") return ru_transcript_export_form_label(inputs)
	if (locale === "es") return es_transcript_export_form_label(inputs)
	if (locale === "zh-CN") return zh_cn2_transcript_export_form_label(inputs)
	if (locale === "ja") return ja_transcript_export_form_label(inputs)
	if (locale === "hi") return hi_transcript_export_form_label(inputs)
	if (locale === "pt-PT") return pt_pt2_transcript_export_form_label(inputs)
	return en_transcript_export_form_label(inputs)
});